export const REQUEST_HOMEOWNER_SYSTEM_GLANCE = "REQUEST_HOMEOWNER_SYSTEM_GLANCE";
export const RECEIVE_HOMEOWNER_SYSTEM_GLANCE = "RECEIVE_HOMEOWNER_SYSTEM_GLANCE";

export const REQUEST_HOMEOWNER_CAMPAIGN = "REQUEST_HOMEOWNER_CAMPAIGN";
export const RECEIVE_HOMEOWNER_CAMPAIGN = "RECEIVE_HOMEOWNER_CAMPAIGN";